import React from 'react'
import styled from 'styled-components'
import { string, bool, func } from 'prop-types'
import Text from '../../shared/Text/'
import {
  METAL,
  LAPTOP_WIDTH,
  VERMILION,
  SILVER,
  SIDE_NAVIGATION_WIDTH_DESKTOP,
  SIDE_NAVIGATION_WIDTH_LAPTOP,
  TEXT_SMALL,
} from '../../../constants'
import { userShape } from '../../../types'
import logo from '../../../assets/logo.png'
import useOrganisations from '../../shared/system/useOrganisations'

import Link from '../../shared/Link'
import UserNavigation from './UserNavigation'
import HeaderRow from './HeaderRow'
import '@fontsource/dm-sans' // Defaults to weight 400

const Logo = styled.img`
  width: 220px;
`

const LogoWrapper = styled.div`
  width: ${SIDE_NAVIGATION_WIDTH_DESKTOP};
  text-align: left;
  position: relative;
  margin-left: 90px;
  display: center;
  @media only screen and (max-width: ${LAPTOP_WIDTH}) {
    width: ${SIDE_NAVIGATION_WIDTH_LAPTOP};
  }
`

const Spacer = styled.div`
  flex-grow: 1;
`

const NavWrapper = styled.div`
  margin-left: 40px;
  display: flex;
`

const NavLink = styled(Link)`
  color: ${METAL};
  box-sizing: border-box;
  height: 30px;
  font-size: 18px;
  font-family: 'DM Sans';
  border-bottom: ${({ selected }) => selected && ` 2px solid ${SILVER}`};
  cursor: pointer;
  display: center;
  margin-right: 30px;

  :hover {
    transition: 0.1s linear
    color: ${METAL};
    border-bottom: ${({ selected }) => !selected && ` 2px solid ${VERMILION}`};
  }
`

const pagePathNames = (isAdmin, organisationId) => [
  { name: 'feeds', link: `${organisationId}/feeds` },
  { name: 'reports', link: `${organisationId}/reports` },
  { name: 'admin', link: `${organisationId}/admin` },
  ...(isAdmin ? [{ name: 'system', link: 'system' }] : []),
]

const TopNavigation = ({
  isAdmin,
  isUser,
  logoutUser,
  rootContextPath,
  t,
  user,
}) => {
  const { selected } = useOrganisations()
  const organisationId = selected.id

  return (
    <HeaderRow>
      <Link link={`${organisationId}/feeds`}>
        <LogoWrapper>
          <Logo src={logo} alt="Company logo" />
          <Text color={METAL} size={TEXT_SMALL} font-weight="bold">
            FeedManager
          </Text>
        </LogoWrapper>
      </Link>
      {isUser && (
        <NavWrapper>
          {pagePathNames(isAdmin, organisationId).map(({ name, link }) => (
            <NavLink
              key={name}
              dataId={`nav-item-${name}`}
              selected={rootContextPath === name}
              link={link}
            >
              {t(name).toUpperCase()}
            </NavLink>
          ))}
        </NavWrapper>
      )}
      <Spacer />
      {isUser && user && <UserNavigation user={user} logoutUser={logoutUser} />}
    </HeaderRow>
  )
}

TopNavigation.propTypes = {
  isAdmin: bool,
  isUser: bool,
  logoutUser: func.isRequired,
  rootContextPath: string,
  user: userShape,
}

export default TopNavigation
